<template>
  <div class="form">
    <slot></slot>
  </div>
</template>

<script lang="js">
export default {
  name: 'Form'
}
</script>

<style scoped>
.form {
  max-width: 1036px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/form.vue